import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { PasswordValidatorsService } from '../services/password-validators.service';
import { FormValidationService } from '../services/form-validation.service';

import { Auth,Storage } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { ModalComponent } from '../shared/modal/modal.component';
import { AuthService } from '../services/auth.service';
import { UsuariosService } from '../services/usuarios.service';
import { EmpresaService } from '../services/empresa.service';
import { PermisosService } from '../services/permisos.service';
import { ReceptorService } from '../services/receptor.service';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { environment } from 'src/environments/environment';
import { PersonalizacionService } from '../services/personalizacion.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { emailAlreadyExist } from './auth.validators';
import countries from '@noe/util/countries';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthComponent implements OnInit {

  @ViewChild('user') userInput:ElementRef
  @ViewChild('passModal') passModal:ModalComponent
  @ViewChild('passModalCorreo') passModalCorreo:ModalComponent
  @ViewChild('recoveryModal') recoveryModal:ModalComponent
  @ViewChild('modalSesion') modalSesion:ModalComponent
  @ViewChild('modalCompletado') modalCompletado:ModalComponent
  @ViewChild('modalCompletadoCorreo') modalCompletadoCorreo:ModalComponent
  @ViewChild('captcha') captcha:InvisibleReCaptchaComponent
  @ViewChild('modalLecturaTerminos') modalLecturaTerminos:ModalComponent
  @ViewChild('modalUsuarioInactivo') modalUsuarioInactivo:ModalComponent

  loginForm:FormGroup
  registrateForm:FormGroup
  passForm:FormGroup
  passCorreoForm:FormGroup
  recoveryForm:FormGroup
  codeForm:FormGroup
  colorTheme: string;
  inputTypeNew = 'password';
  inputType = 'password';
  inputTypePassNew = 'password';
  inputTypePass = 'password';

  constructor(
    private fb: FormBuilder,
    private fv: FormValidationService,
    private formValidation: FormValidationService,
    private router: Router,
    private renderer: Renderer2,
    public validators: PasswordValidatorsService,
    public usuarioService: UsuariosService,
    public authService: AuthService,
    public permisosService: PermisosService,
    public empresaService: EmpresaService,
    public personalizacionService:PersonalizacionService,
    public receptorService:ReceptorService,
    public notify: NotificationsService,
    private route: ActivatedRoute,
  ) { }

  errorSubdominio:boolean
  subdominio:string
  imagenCentral:string
  fondoCentral:string
  logoWeb:string

  theValue:string;
  type:string;
  verLogin: boolean = true;
  verRegistrateForm: boolean = false;
  verRegistrate: boolean = false;
  rememberMe: boolean = false;
  idDocSelect:any = null;
  verRecoveryForm: boolean = false;
  verCodeForm: boolean = false;
  usuarioNuevo: boolean = false;
  datoUser: string;
  datoPassword: string;
  existeDni:boolean=false;
  validacionDni: string;
  validarCheck: boolean = false;
  rememberCheck:string;
  usuarioPass: boolean = false;
  emailCorreo: string;

  countries: any[] = [...countries]
  .sort((a, b) => a.es.localeCompare(b.es))
  .map((item) => {
    return {
      ...item,
      optionName: `${item.es} (${item.dial})`
    }
  });

  ngOnInit(): void {
    this.datoUser = sessionStorage.getItem('rememberUser');
    this.datoPassword = sessionStorage.getItem('rememberPassword');
    this.rememberCheck = sessionStorage.getItem('rememberCheck');
    localStorage.setItem('rememberUser', this.datoUser);
    localStorage.setItem('rememberPassword', this.datoPassword);
    localStorage.setItem('rememberCheck', this.rememberCheck);
    const remember = localStorage.getItem("rememberCheck") === 'true'
    //this.scriptTraductorStyle();
    //this.scriptTraductor();
    this.scriptNiubiz();
    const url:string = window.location.href
    this.subdominio = url.split('.')[0].split('//')[1]
    this.obtenerEmail();
    // this.renderer.addClass(document.body, 'login')

    const passwordValidators = this.validators.set()
    const captchaValidators = environment.TESTING ? [] : [Validators.required]

    this.loginForm = this.fb.group({
      user: ['', [Validators.required]],
      password: ['', [Validators.required]],
      remember: [ remember ? true : false],
      recaptcha: ['', captchaValidators]
    })

    this.registrateForm = this.fb.group({
      name: ['', [Validators.required]],
      paternalSurname: ['',[Validators.required]],
      nationalType: ['',[Validators.required]],
      phoneNumber: ['',[Validators.required,Validators.minLength(9),Validators.maxLength(9)]],
      identityType: ['',[Validators.required]],
      identityNumber: ['',[Validators.required,Validators.minLength(8),Validators.maxLength(12)]],
      email: ['',[Validators.required, Validators.email], emailAlreadyExist(this.usuarioService, this.authService)],
      password: ['',passwordValidators],
      autorizar: [false],
      declarar: [false, [Validators.required]],
      recaptcha: ['']
    })

    this.passForm = this.fb.group({
      password: ['', passwordValidators],
      confirm: ['', [Validators.required]]
    }, { validators: this.checkPasswords })

    this.passCorreoForm = this.fb.group({
      code: ['', [Validators.required]],
      password: ['', passwordValidators],
      confirm: ['', [Validators.required]]
    }, { validators: this.checkPasswords })

    this.recoveryForm = this.fb.group({
      user: ['', [Validators.required]]
    })

    this.codeForm = this.fb.group({
      user: ['', [Validators.required]],
      code: ['', [Validators.required]],
      password: ['', passwordValidators],
      confirm: ['', [Validators.required]]
    }, { validators: this.checkPasswords })

    this.obtenerImagenesPersonalizacion();

    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('modal-open');
  }

  obtenerEmail() {
    this.route.queryParams.subscribe(params => {
      this.emailCorreo = params['email']
      if(this.emailCorreo != undefined ) {
        console.log(this.emailCorreo, 'emailCorreo');
        this.afterRecoverValidationEmail(params['email']);
      }
    });
  }

  // Recuperar contraseña - validacion RedSocial
  async afterRecoverValidationEmail(email){
    this.errorUsuarioRedSocial = false;
    this.errorNoVerificado = false;
    this.errorNoExiste = false;
    this.errorTemporal = false;
    this.maximoDeIntentos = false;

    this.receptorService.obtenerUsuarioProvider(this.emailCorreo,this.subdominio).subscribe( data => {
      console.log(data.response)
      if(data.response != null){
        //console.log('#userCreator', data.response.userCreator)
        if(data.response.userCreator == 'GOOGLE' || data.response.userCreator == 'SIGNINWITHAPPLE' || data.response.userCreator == 'FACEBOOK'){
          this.errorUsuarioRedSocial =  true;
          this.rLoading = false
        }else{
          //console.log('Entra a recuperar contraseña')
          this.rLoading = false
          this.loginForm.controls['user'].setValue(email)
          this.loginForm.controls['password'].setValue(data.response.identityNumber)
          this.captcha.execute()
          this.login('e')
          //this.loginMigracion()
          //this.recoverEmail();
        }
      }else{
        this.errorNoExiste = true;
        //this.rLoading = false;
      }
    }, error => {
      console.log(error)
      //this.rLoading = false;
    })
  }

  async loginMigracion(){
    try {
      this.user = await Auth.signIn(this.loginForm.get('user').value.trim(),this.loginForm.get('password').value);
      this.authService.handleTokenExpiration();

      // Cambiar contraseña temporal
      if (this.user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.loading = false
        this.passModal.open()

      // Login
      } else {

        this.dologin()

      }

    } catch (err) {
      console.log(err)
      this.loading = false
      if(err.message == 'User is disabled.') {
        this.modalUsuarioInactivo.open();
      }
      if (err.code == 'NotAuthorizedException' || err.code == 'UserNotFoundException') {
        this.errorCredenciales = true
      }
      if (err.code == 'NetworkError') {
        // this.errorConexion = true
      }
      if (err.code == 'PasswordResetRequiredException') {
        this.errorReset = true
      }
    }
  }

  // Recuperar contraseña
  async recoverEmail() {
    // Pre Auth
    try {
      await this.authService.preRecover(this.emailCorreo, this.subdominio)
    } catch (error) {
      this.loading = false
      console.log(error)
      return
    }

    try {
      let data = await Auth.forgotPassword(this.emailCorreo)

      this.notify.success('El código se envió directamente.');
      this.passModalCorreo.open();
      console.log(this.emailCorreo, 'user');

    } catch (err) {

      if (err.code == 'InvalidParameterException') {
        this.errorNoVerificado = true
      } else if (err.code == 'UserNotFoundException') {
        this.errorNoExiste = true
      } else if (err.code == 'NotAuthorizedException') {
        this.errorNoExiste = true
        if(this.errorNoExiste){
          console.log('reestablecer',this.errorNoExiste)
        }else{
          this.reestablecerEmail();
        }

      } else if (err.code === 'LimitExceededException') {
        this.maximoDeIntentos = true
      }
      if (!this.errorTemporal) this.rLoading = false
    }
  }

  reestablecerEmail() {
    this.usuarioService.RestablecerContrasena(
      this.emailCorreo,
      this.subdominio).subscribe(data => {
        console.log(data,'reestablecerEmail')
        this.passModalCorreo.open();
    }, error => {
      console.log(error)
    })
  }

  // Establecer contraseña recuperada
  async submitCodeCorreo(e) {

    e.preventDefault()
    if (this.cLoading) return
    this.usuarioPass = true;
    this.captcha.execute()
    if (this.passCorreoForm.invalid) {

      return this.formValidation.validateForm(this.passCorreoForm)
    }

    this.pLoading = true

    try {
      console.log("Entras aqui..")
        await Auth.forgotPasswordSubmit(
        this.emailCorreo,
        this.passCorreoForm.get('code').value.trim(),
        this.passCorreoForm.get('password').value)

        this.user = await Auth.signIn(this.emailCorreo, this.passCorreoForm.get('password').value);
        //this.authService.handleTokenExpiration();
        //this.dologin();
        this.pLoading = false;
        this.passModalCorreo.close();
        this.openModalCompletadoCorreo();
    } catch (err) {
      console.log(err)
      if (err.code === 'CodeMismatchException') this.errorCode = true
      // else this.notify.error('Hubo un problema al procesar la solicitud')
      this.pLoading = false;
    }

  }

  validarEspacios(e) {
    let stringEspacios = e.target.value;
    e.target.value = stringEspacios.trim();
    //console.log(e.target.value, 'valor')
  }

  restablecerValidacion() {
    Object.keys(this.loginForm.controls).forEach((key) => {
      const control = this.loginForm.controls[key];
      control.setErrors(null);
    });
  }

  rememberUser() {
    this.rememberMe = this.loginForm.get('remember').value
    if (!this.rememberMe) {
      sessionStorage.setItem('rememberUser', this.loginForm.get('user').value);
      sessionStorage.setItem('rememberPassword', this.loginForm.get('password').value);
      sessionStorage.setItem('rememberCheck', 'true');
      this.restablecerValidacion();
    } else {
      sessionStorage.setItem('rememberUser', "");
      sessionStorage.setItem('rememberPassword', "");
      sessionStorage.setItem('rememberCheck', "false");
      this.restablecerValidacion();
    }
  }

  abrirModalLecturaTerminos(){
    this.modalLecturaTerminos.open();
  }

  get emailControl(): FormControl {
    return <FormControl> this.registrateForm.get('email');
  }

  get dniControl(): FormControl {
    return <FormControl> this.registrateForm.get('identityNumber');
  }

  openModalCompletado() {
    this.modalCompletado.open();
  }

  closeModalCompletado() {
    this.modalCompletado.close();
    this.authService.handleTokenExpiration();
    this.dologin();
  }

  openModalCompletadoCorreo() {
    this.modalCompletadoCorreo.open();
  }

  closeModalCompletadoCorreo() {
    this.modalCompletadoCorreo.close();
    this.authService.handleTokenExpiration();
    this.dologinCorreo();
  }

  parseJwt (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
  };

  crearLoading:boolean
  existeEmail:boolean=false
  subDominio : string
  subDominioFree:string
  companies:any

  validarContacto() {
    console.log(this.registrateForm.controls['email'].value, 'email')
    this.usuarioService.obtenerUsuario(
      this.registrateForm.controls['email'].value,
      this.subDominioFree
    ).subscribe(data => {

      if(!!data && data.status == 1){
        this.existeEmail=true
      }else{
        this.existeEmail=false
      }
      console.log(this.existeEmail,'existeEmail')
    }, error => {
      console.log(error)
      //this.crearLoading = false
      if (error.status === 409) this.existeEmail=false
      else this.notify.error('Hubo un problema al validar el contacto')
    })
  }

  valorDni: any;
  correoRegistro: string;
  validarDni() {
    console.log(this.registrateForm.controls['email'].value, 'email')

    this.correoRegistro = this.registrateForm.controls['email'].value;
    this.usuarioService.obtenerUsuario(
      this.registrateForm.controls['email'].value,
      this.subDominioFree
    ).subscribe(data => {
      this.valorDni = this.registrateForm.controls['identityNumber'].value
      if(!!data && data.status == 1){
        if( this.valorDni == data.identityNumber) {
          this.existeDni=true;
        } else{
          this.existeDni=false
        }
      } else{
        this.existeDni=false
      }
    }, error => {
      console.log(error)
      //this.crearLoading = false
      if (error.status === 409) this.existeDni=false
      else this.notify.error('Hubo un problema al validar el dni')
    })
  }

  checkDeclarar(check:boolean){
    this.validarCheck = check;
  }

  loadingAccount:boolean = false;
  registro(e) {
    this.subDominioFree = this.authService.obtenerSubdomain()
    console.log('subdominio freee', this.subDominioFree)

    //this.validarContacto();
    this.existeDni = false;

    if (!this.registrateForm.valid && this.validarCheck) {
      return this.fv.validateForm(this.registrateForm)
    }

    this.loadingAccount = true;
    const nationality = this.registrateForm.get('nationalType').value;
    const countryCode = countries.find((item) => item.code === nationality)?.dial;

    let body: any = {
      name: this.registrateForm.get('name').value,
      paternalSurname: this.registrateForm.get('paternalSurname').value,
      phoneNumber: countryCode + this.registrateForm.get('phoneNumber').value,
      identityType: this.idDocSelect,
      identityNumber: this.registrateForm.get('identityNumber').value,
      email: this.registrateForm.get('email').value,
      password: this.registrateForm.get('password').value.trim(),
      autorizar: this.registrateForm.get('autorizar').value,
      declarar: this.registrateForm.get('declarar').value,
      subdomain: this.authService.obtenerSubdomain(),
      companys: this.companies,
      nationalType: 'PE',
      maternalSurname: '',
      document_type: [],
      document_visado: [],
      document_control: [],
      office: 0,
      idProfile: "[2]",
      role: [1],
      idTipoFirma: "[1,2,4,5]",
      idOfficesArray: "[]",
      flagAttributesCompany: 0,
      login: this.registrateForm.get('identityNumber').value,
      editSignigProcess: false,
      enableSignigProcess: false,
      permanent: "true"
    }

    console.log('body', body)
    this.receptorService.createUserFree(body).subscribe(data => {
        console.log(data)
        this.notify.success('Creación exitosa')
        this.usuarioNuevo = true;
        this.existeEmail=false;
        this.loginUsuario(e);
        this.loadingAccount = false
     }, error => {
      console.log("############",error)
      this.crearLoading = false
      if (error.status === 409) {
        this.existeEmail=true
      } else if (error.status === 410) {
        this.existeEmail = false
        this.validacionDni = error.error.message
        this.existeDni = true;
      } else {
        this.notify.error('Hubo un problema al crear el usuario')
      }
      this.loadingAccount = false
    });

    /*if(!this.registrateForm.invalid && (this.registrateForm.get('declarar').value == true) && !this.existeEmail) {
      this.empresaService.informacionEmpresaFree(this.subDominioFree).subscribe(data => {
        console.log('data empresa', data)
        this.companies = data
        console.log('data empresasss', this.companies)

        const nationality = this.registrateForm.get('nationalType').value;
        const countryCode = countries.find((item) => item.code === nationality)?.dial;

        let user: any = {
          name: this.registrateForm.get('name').value,
          paternalSurname: this.registrateForm.get('paternalSurname').value,
          phoneNumber: countryCode + this.registrateForm.get('phoneNumber').value,
          identityType: this.idDocSelect,
          identityNumber: this.registrateForm.get('identityNumber').value,
          email: this.registrateForm.get('email').value,
          password: this.registrateForm.get('password').value,
          autorizar: this.registrateForm.get('autorizar').value,
          declarar: this.registrateForm.get('declarar').value,
          subdomain: this.authService.obtenerSubdomain(),
          companys: this.companies,
          nationalType: 'PE',
          maternalSurname: '',
          document_type: [],
          document_visado: [],
          document_control: [],
          office: 0,
          idProfile: "[2]",
          role: [1],
          idTipoFirma: "[1,2,4,5]",
          idOfficesArray: "[]",
          flagAttributesCompany: 0,
          login: this.registrateForm.get('identityNumber').value,
          editSignigProcess: false,
          enableSignigProcess: false,
          permanent: "true"
        }

        console.log(user, 'registro')

        this.usuarioService.crearUsuario(user).subscribe(data => {
          this.notify.success('Creación exitosa')
          //this.verRegistrate = false
          //this.verLogin = true
          //this.verRegistrateForm = false
          this.usuarioNuevo = true;

          this.loginUsuario(e);

          console.log(this.usuarioNuevo, 'usuarioNuevo')
        }, error => {
          console.log(error)
          this.crearLoading = false
          if (error.status === 409) {
           this.existeEmail = false
           this.validacionDni = error.error
           this.existeDni = true;
          } else {
            this.notify.error('Hubo un problema al crear el usuario')
          }
        })

      }, error => {
        console.log(error)
        this.crearLoading = false
        if (error.status === 409) this.existeEmail = false
        else this.notify.error('Hubo un problema al crear el usuario')
      })

    }*/
  }

  setFilter(event) {
    if (event != '') {
      let value = '';

      if (this.type == 'select') {
        value = event.target.value
      }

      this.theValue = '';
    }

  }

  options = [
    { name: "DNI", id: 1 },
    { name: "CE", id: 2 },
    { name: "PTP", id: 3 },
    { name: "pasaporte", id: 4 },
    //{ name: "RUC", id: 2 },
  ];

  getChangeDoc(id:any){
    this.idDocSelect = id
  }

  onLoginGoogle() : void {
    localStorage.setItem('ACCESS_LOGIN', 'GOOGLE')
    localStorage.setItem('ACESS_SUB', this.subdominio)
    Auth.federatedSignIn({
        provider: CognitoHostedUIIdentityProvider.Google,
    })
  }

  onLoginApple() : void {
    localStorage.setItem('ACCESS_LOGIN', 'SIGNINWITHAPPLE')
    localStorage.setItem('ACESS_SUB', this.subdominio)
    Auth.federatedSignIn({
        provider: CognitoHostedUIIdentityProvider.Apple,
    })
  }

  onLoginFacebook() : void {
    localStorage.setItem('ACCESS_LOGIN', 'FACEBOOK')
    localStorage.setItem('ACESS_SUB', this.subdominio)
    Auth.federatedSignIn({
        provider: CognitoHostedUIIdentityProvider.Facebook,
    })
  }

  scriptTraductor() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(script);
  }

  scriptTraductorStyle() {
    var jq = document.createElement("script");
    jq.type = "text/javascript";
    jq.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js";
    document.body.appendChild(jq);
  }

  scriptNiubiz() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = environment.scriptNiubiz;
    document.body.appendChild(script);
    console.log('script niubiz',script)
  }

  loadingImagenes:boolean =true
  obtenerImagenesPersonalizacion(){
    this.loadingImagenes = true

    this.personalizacionService.listarImagenesPersonalizacion(this.subdominio).subscribe((data:any) => {

      this.loadingImagenes = false
      this.colorTheme = data.color;
      localStorage.setItem('customData', JSON.stringify(data));

      this.imagenCentral=data.imageCentralWeb
      this.fondoCentral=data.fondoWeb
      //this.logoWeb = data.logoWeb
      this.logoWeb = '../../../assets/img/logo-1.png';
      if(this.fondoCentral == "" || this.fondoCentral == null){
        this.fondoCentral = '../../assets/img/fondo-azul.jpg'
      }
      if(this.imagenCentral == "" || this.imagenCentral == null){
        this.imagenCentral = '../../assets/img/imagen-central.jpg'
      }

      this.actualizarImagenesPersonalizacion();

      //this.fondoWeb=data.imageCentralWeb
     //this.imagenCentral = "public/firmas_holograficas/00001111/1615999823880.jpg"


    }, error => {
      this.loadingImagenes = false

    })

  }

  actualizarImagenesPersonalizacion(){
      if(!this.verRegistrate && this.verLogin && !this.verRecoveryForm && !this.verCodeForm || this.imagenCentral == "" || this.imagenCentral == null){
        this.imagenCentral = '../../assets/img/noe-free/login.png'
      }

      if(this.verRegistrate && !this.verLogin && !this.verRecoveryForm && !this.verCodeForm || this.imagenCentral == "" || this.imagenCentral == null){
        this.imagenCentral = '../../assets/img/noe-free/registro-correo.png'
      }

      if(!this.verRegistrate && !this.verLogin && !this.verRecoveryForm && !this.verCodeForm || this.imagenCentral == "" || this.imagenCentral == null){
        this.imagenCentral = '../../assets/img/noe-free/registrate.png'
      }

      if((this.verRecoveryForm || this.verCodeForm) && !this.verRegistrate && !this.verLogin || this.imagenCentral == "" || this.imagenCentral == null){
        this.imagenCentral = '../../assets/img/noe-free/olvido-contrasena.png'
      }
  }

  sessionMsg:string = 'Su sesión ha sido terminada por inactividad'
  ngAfterViewInit() {
    // if (JSON.parse(sessionStorage.getItem('LOGGED_OUT'))) setTimeout(() => {
    //   if(JSON.parse(sessionStorage.getItem('EXPIRED'))) this.sessionMsg = 'Parece que su sesión ha expirado'
    //   this.modalSesion.open()
    //   sessionStorage.clear()
    // }, 500)
  }

  errorCredenciales:boolean
  errorReset:boolean
  loading:boolean
  user:any
  siteKey:string = environment.captchaSiteKey
  recaptcha:string

  get f() { return this.loginForm.controls; }

  checkCaptcha(e) {
    if (environment.TESTING) {
        this.login(e);
    } else {
     // if (this.btnLoad) return

      //this.btnLoad = true
      this.captcha.execute()

    }

  }

  checkCaptchaUsuario(e) {
    this.registro(e);

    if (environment.TESTING) {

    } else {
      this.captcha.execute()
    }

  }

  async login(e) {
  //  e.preventDefault()

    if (this.loading) return

    if (this.loginForm.invalid) {
      return this.formValidation.validateForm(this.loginForm)
    }

    this.loading = true

    // Pre Auth
    /*try {
      this.errorSubdominio = false
      await this.authService.preAuth(this.loginForm.get('user').value.trim(), this.subdominio,this.f.recaptcha.value)
    } catch (error) {
      this.errorSubdominio = true
      this.loading = false

      return
    }*/

    try {
      this.user = await Auth.signIn(this.loginForm.get('user').value.trim(),this.loginForm.get('password').value);
      this.authService.handleTokenExpiration();

      // Cambiar contraseña temporal
      if (this.user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.loading = false
        this.passModal.open()

      // Login
      } else {

        this.dologin()

      }

    } catch (err) {
      console.log(err)
      this.loading = false
      if(err.message == 'User is disabled.') {
        this.modalUsuarioInactivo.open();
      }
      if (err.code == 'NotAuthorizedException' || err.code == 'UserNotFoundException') {
        this.errorCredenciales = true
      }
      if (err.code == 'NetworkError') {
        // this.errorConexion = true
      }
      if (err.code == 'PasswordResetRequiredException') {
        this.errorReset = true
      }
    }
  }

  async loginUsuario(e) {
  //  e.preventDefault()

    console.log(this.registrateForm.get('email').value, this.registrateForm.get('password').value, 'email - password')

    if (this.loading) return

    this.loading = true

    // Pre Auth
   /* try {
      this.errorSubdominio = false
      await this.authService.preAuth(this.registrateForm.get('email').value.trim(), this.subdominio,this.f.recaptcha.value)
    } catch (error) {
      this.errorSubdominio = true
      this.loading = false

      return
    }*/

    try {
      this.user = await Auth.signIn(this.registrateForm.get('email').value.trim(),this.registrateForm.get('password').value);
      this.authService.handleTokenExpiration();

      // Cambiar contraseña temporal
      if (this.user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.loading = false
        this.passModal.open()

      // Login
      } else {

        this.dologinUsuarioNuevo()

      }

    } catch (err) {
      console.log(err)
      this.loading = false
      if(err.message == 'User is disabled.') {
        this.modalUsuarioInactivo.open();
      }
      if (err.code == 'NotAuthorizedException' || err.code == 'UserNotFoundException') {
        this.errorCredenciales = true
      }
      if (err.code == 'NetworkError') {
        // this.errorConexion = true
      }
      if (err.code == 'PasswordResetRequiredException') {
        this.errorReset = true
      }
    }
  }

  reset() {
    //this.btnLoad = false
  }
  ready() {
  }
  load() {
  }
  success(e) {
    if(this.usuarioNuevo && !this.usuarioPass) {
      this.registrateForm.controls['recaptcha'].setValue(e)
      this.loginUsuario(e)
      console.log('success')
    } else if(!this.usuarioNuevo && !this.usuarioPass){
      this.loginForm.controls['recaptcha'].setValue(e)
      console.log('login default');
      this.login(e)
    }

    if(this.usuarioPass) {
      this.loginForm.controls['recaptcha'].setValue(e)
      console.log('login usuarioPass');
    }
  }

  expire() {
    //this.btnLoad = false
  }
  error() {
    //this.btnLoad = false
  }


  // Cambiar contraseña temporal
  pLoading:boolean
  async completarPass(e) {

    e.preventDefault()
    if (this.pLoading) return
    if (this.passForm.invalid) {

      return this.formValidation.validateForm(this.passForm)
    }

    this.pLoading = true

    try {

      this.user = await Auth.completeNewPassword(
      this.user,
      this.passForm.get('password').value)

      this.receptorService.actualizarFechaContraseña(this.loginForm.get('user').value.trim(), this.subdominio).subscribe(
        data => {
          console.log('FECHA CONTRASEÑA ACTUALIZADA')
        }
      );

      // return
      this.authService.handleTokenExpiration();
      this.dologin()

    } catch (err) {
      console.log(err)
      this.pLoading = false
    }

  }


  recovery() {
    this.recoveryModal.open()
  }

  rLoading:boolean
  errorNoVerificado:boolean
  errorNoExiste:boolean
  errorTemporal:boolean
  errorUsuarioRedSocial:boolean
  insertCode:boolean
  code:string

  // Recuperar contraseña - validacion RedSocial
  async afterRecoverValidation(e){
    this.errorUsuarioRedSocial = false;
    this.errorNoVerificado = false;
    this.errorNoExiste = false;
    this.errorTemporal = false;
    this.maximoDeIntentos = false;

    e.preventDefault()
    if (this.rLoading) return
    if (this.recoveryForm.invalid) {
      return this.formValidation.validateForm(this.recoveryForm)
    }
    this.rLoading = true
    this.rLoading = false
    this.recover(e);

    /*this.receptorService.obtenerUsuarioProvider(this.recoveryForm.get('user').value.trim(),this.subdominio).subscribe( data => {
      if(data.response != null){
        //console.log('#userCreator', data.response.userCreator)
        if(data.response.userCreator == 'GOOGLE' || data.response.userCreator == 'SIGNINWITHAPPLE' || data.response.userCreator == 'FACEBOOK'){
          this.errorUsuarioRedSocial =  true;
          this.rLoading = false
        }else{
          //console.log('Entra a recuperar contraseña')
          this.rLoading = false
          this.recover(e);
        }
      }else{
        this.errorNoExiste = true;
        this.rLoading = false;
      }
    }, error => {
      console.log(error)
      this.rLoading = false;
    })*/
  }

  // Recuperar contraseña
  async recover(e) {
    // Pre Auth


    // Pre Auth
    // try {
    //   this.errorSubdominio = false
    //   await this.authService.preAuth(this.recoveryForm.get('user').value.trim(), this.subdominio, this.f.recaptcha.value)
    // } catch (error) {
    //   this.errorSubdominio = true
    //   this.rLoading = false
    //   console.log(error)
    //   return
    // }

    try {
      let data = await Auth.forgotPassword(this.recoveryForm.get('user').value.trim())
      this.codeForm.controls['user'].setValue(this.recoveryForm.get('user').value.trim())
      this.codeForm.updateValueAndValidity()
      this.insertCode = true
      this.verRecoveryForm = false;
      this.verCodeForm = true;
      this.notify.success('El código se envió directamente.');
      console.log(this.recoveryForm.get('user').value, 'user');

    } catch (err) {

      if (err.code == 'InvalidParameterException') {
        this.errorNoVerificado = true
      } else if (err.code == 'UserNotFoundException') {
        this.errorNoExiste = true
      } else if (err.code == 'NotAuthorizedException') {
        //this.errorTemporal = true // esta es su validación verdadera
        this.errorNoExiste = true
        if(this.errorNoExiste){
          console.log('reestablecer',this.errorNoExiste)
        }else{
          this.reestablecer()
        }


      } else if (err.code === 'LimitExceededException') {
        this.maximoDeIntentos = true
      }
      if (!this.errorTemporal) this.rLoading = false
    }

    try {
      await this.authService.preRecover(this.recoveryForm.get('user').value.trim(), this.subdominio)
    } catch (error) {
      this.loading = false
      console.log(error)
      return
    }
  }



  correoUsuario:string = ''
  reestablecer() {
    this.verRecoveryForm = false;
    this.verCodeForm = true;

    this.usuarioService.RestablecerContrasena(
      this.recoveryForm.get('user').value.trim(),
      this.subdominio).subscribe(data => {
      this.correoUsuario = this.recoveryForm.get('user').value.trim()
      this.rLoading = false
      // this.notify.success('Operación exitosa')
      // this.loaders[loader] = false
      // this.buildBody()

    }, error => {
      console.log(error)
      this.rLoading = false
      // this.notify.error('Hubo un error inesperado')
      // this.loaders[loader] = false
    })
  }

  cLoading:boolean
  maximoDeIntentos:boolean
  errorCode:boolean
  // Establecer contraseña recuperada
  async submitCode(e) {

    e.preventDefault()
    if (this.cLoading) return
    this.usuarioPass = true;
    this.captcha.execute()
    if (this.codeForm.invalid) {

      return this.formValidation.validateForm(this.codeForm)
    }

    this.cLoading = true

    try {
      console.log("Entras aqui..")
        await Auth.forgotPasswordSubmit(
        //this.codeForm.get('user').value,
        this.recoveryForm.get('user').value,
        this.codeForm.get('code').value.trim(),
        this.codeForm.get('password').value)

        //this.user = await Auth.signIn(this.codeForm.get('user').value.trim(), this.codeForm.get('password').value);
        this.user = await Auth.signIn(this.codeForm.get('user').value.trim(), this.codeForm.get('password').value);
        //this.authService.handleTokenExpiration();
        //this.dologin();
        this.openModalCompletado();
    } catch (err) {
      console.log(err)
      if (err.code === 'CodeMismatchException') this.errorCode = true
      // else this.notify.error('Hubo un problema al procesar la solicitud')
      this.cLoading = false
      //this.openModalCompletado();
    }

  }

  clearRecovery() {
    this.errorNoVerificado = false
    this.errorNoExiste = false
    this.errorTemporal = false
    this.maximoDeIntentos = false
    this.code = null
    this.rLoading = false
    this.insertCode = null
    this.recoveryForm.reset()
    this.codeForm.reset()
    // this.correoUsuario = null
    this.errorCode = false
  }

  checkPasswords(group: FormGroup) {
    let pass = group.get('password').value;
    let confirmPass = group.get('confirm').value;
    return pass === confirmPass ? null : { mismatch: true }
  }

  async dologin() {
    console.log(this.user['attributes'], 'atributtes')
    const user = this.loginForm.get('user').value || this.codeForm.get('user').value.trim()
    const subdomains:string = this.user['attributes'] ? this.user['attributes']['custom:subdomain'] : this.user['challengeParam']['userAttributes']['custom:subdomain']
    const parseSubdomains = JSON.parse(subdomains)
    let subdomain = ""
    parseSubdomains.forEach(element => {
      if (element.name == this.subdominio){
        subdomain = element.name
      }
    });
    this.usuarioPass = false;
    console.log("inicio de session")
    localStorage.setItem('AUTHUSER', user)
    localStorage.setItem('AUTHSUBDOMINIO', subdomain)
    localStorage.setItem('AUTHRECAPCHA', this.f.recaptcha.value)
    localStorage.setItem('AUTHSTART', 'start')
    this.router.navigate(['/'])
    /*this.usuarioService.obtenerUsuario(user, subdomain).subscribe(data => {

      this.authService.guardarDatos(data)
      this.permisosService.setOpciones()

      this.empresaService.obtenerEmpresaActiva(this.authService.obtenerIdEmpresaActiva()).subscribe(data => {

        this.authService.guardarDataEmpresaActiva(data.find(c => c.id == this.authService.obtenerIdEmpresaActiva()))

        //this.router.navigate(['/'], {queryParams: {login:1}})
        this.router.navigate(['/'])
      }, error => {
        console.log(error)
        this.errorLogout()
      })

    }, error => {
      console.log(error)
      this.errorLogout()
    })*/

  }

  async dologinCorreo() {
    console.log(this.user['attributes'], 'atributtes')
    const user = this.emailCorreo || this.passCorreoForm.get('code').value.trim()
    const subdomains:string = this.user['attributes'] ? this.user['attributes']['custom:subdomain'] : this.user['challengeParam']['userAttributes']['custom:subdomain']
    const parseSubdomains = JSON.parse(subdomains)
    let subdomain = ""
    parseSubdomains.forEach(element => {
      if (element.name == this.subdominio){
        subdomain = element.name
      }
    });
    this.usuarioPass = false;
    console.log("inicio de session")
    localStorage.setItem('AUTHUSER', user)
    localStorage.setItem('AUTHSUBDOMINIO', subdomain)
    localStorage.setItem('AUTHRECAPCHA', this.f.recaptcha.value)
    localStorage.setItem('AUTHSTART', 'start')
    this.router.navigate(['/'])
  }

  async dologinUsuarioNuevo() {
    console.log(this.user['attributes'], 'atributtes')

    const user = this.registrateForm.get('email').value || this.codeForm.get('user').value.trim()
    const subdomains:string = this.user['attributes'] ? this.user['attributes']['custom:subdomain'] : this.user['challengeParam']['userAttributes']['custom:subdomain']

    const parseSubdomains = JSON.parse(subdomains)
    let subdomain = ""
    parseSubdomains.forEach(element => {
      if (element.name == this.subdominio){
        subdomain = element.name
      }
    });

    console.log("inicio de session nuevo registro")
    localStorage.setItem('AUTHUSER', user)
    localStorage.setItem('AUTHSUBDOMINIO', subdomain)
    localStorage.setItem('AUTHRECAPCHA', this.f.recaptcha.value)
    localStorage.setItem('AUTHSTART', 'start')
    this.router.navigate(['/'])

   /* this.usuarioService.obtenerUsuario(user, subdomain).subscribe(data => {

      this.authService.guardarDatos(data)
      console.log(data, 'data')
      this.permisosService.setOpciones()

      this.empresaService.obtenerEmpresaActiva(this.authService.obtenerIdEmpresaActiva()).subscribe(data => {

        this.authService.guardarDataEmpresaActiva(data.find(c => c.id == this.authService.obtenerIdEmpresaActiva()))

        //this.router.navigate(['/'], {queryParams: {login:1}})
        this.router.navigate(['/'])
      }, error => {
        console.log(error)
        this.errorLogout()
      })

    }, error => {
      console.log(error)
      this.errorLogout()
    })*/

  }

  async errorLogout() {
    await Auth.signOut({ global: true });
    localStorage.clear()
    this.loading = false
  }
}
